import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-white/95 backdrop-blur-sm shadow-lg" : "bg-transparent"
        }`}
      >
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="p-0 border-none bg-transparent"
              >
                <img
                  src={isScrolled ? "/logoAzulSalbox.png" : "/LogoNaranjaSalbox.png"}
                  alt="Salbox"
                  className="h-8 w-auto transition-opacity duration-300 cursor-pointer"
                />
              </button>
            </div>

            <div className="hidden lg:flex items-center space-x-6">
              <a
                href="/#cobertura"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Cobertura
              </a>
              <a
                href="/#como-funciona"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Cómo Funciona
              </a>
              <a
                href="/#comparacion"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Comparación
              </a>
              <a
                href="/#menu"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Menú
              </a>
              <a
                href="/#resenas"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Reseñas
              </a>
              <Link
                to="/privacy-policy"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Privacidad
              </Link>
              <Link
                to="/terms-conditions"
                className={`font-lufga text-sm transition-colors duration-300 ${
                  isScrolled
                    ? "text-salbox-neutral-700 hover:text-salbox-primary"
                    : "text-salbox-neutral-600 hover:text-salbox-primary"
                }`}
              >
                Términos
              </Link>
            </div>

            <div className="flex items-center gap-4">
              <Button
                className="hidden sm:inline-flex bg-salbox-secondary hover:bg-salbox-secondary-600 text-white font-lufga-medium"
                onClick={() =>
                  document
                    .getElementById("pide-ya")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Pide Ya!
              </Button>

              <button
                className="lg:hidden p-2"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6 text-salbox-primary" />
                ) : (
                  <Menu
                    className={`w-6 h-6 ${
                      isScrolled
                        ? "text-salbox-primary"
                        : "text-salbox-neutral-800"
                    }`}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Menú móvil - COMPLETAMENTE SEPARADO */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "white",
            zIndex: 9999
          }}
        >
          {/* Header del menú móvil */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 24px",
              height: "80px",
              backgroundColor: "white"
            }}
          >
            <button
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setIsMobileMenuOpen(false);
              }}
              style={{
                padding: "0",
                border: "none",
                background: "transparent",
                cursor: "pointer"
              }}
            >
              <img
                src="/logoAzulSalbox.png"
                alt="Salbox"
                style={{ height: "32px", width: "auto" }}
              />
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              style={{
                background: "none",
                border: "none",
                padding: "8px",
                cursor: "pointer"
              }}
            >
              <X className="w-6 h-6 text-salbox-primary" />
            </button>
          </div>

          {/* Contenido del menú */}
          <div style={{ padding: "24px", display: "flex", flexDirection: "column", gap: "16px" }}>
            <a
              href="/#cobertura"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Cobertura
            </a>
            <a
              href="/#como-funciona"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Cómo Funciona
            </a>
            <a
              href="/#comparacion"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Comparación
            </a>
            <a
              href="/#menu"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Menú
            </a>
            <a
              href="/#resenas"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Reseñas
            </a>
            <Link
              to="/privacy-policy"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Privacidad
            </Link>
            <Link
              to="/terms-conditions"
              style={{ padding: "12px 0", fontSize: "18px", fontWeight: "600", color: "#374151" }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Términos
            </Link>

            <Button
              className="w-full mt-8 bg-salbox-secondary hover:bg-salbox-secondary-600 text-white font-lufga-medium py-3 text-lg"
              onClick={() => {
                document.getElementById("pide-ya")?.scrollIntoView({ behavior: "smooth" });
                setIsMobileMenuOpen(false);
              }}
            >
              Pide Ya!
            </Button>
          </div>
        </div>
      )}
    </>
  );
};